import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { DropdownContext } from './DropdownContext';

const Dropdown = ({ children }) => {
  const container = useRef();
  const [isOpen, setIsOpen] = useState(false);
  const toggle = useCallback(() => setIsOpen((prevIsOpen) => !prevIsOpen), [setIsOpen]);
  const value = useMemo(
    () => ({
      isOpen,
      toggle,
    }),
    [isOpen, toggle]
  );

  useEffect(() => {
    function handleDocumentClick(e) {
      if (container.current.contains(e.target) && container.current !== e.target) {
        return;
      }

      if (!container.current.contains(e.target) && container.current !== e.target) {
        setIsOpen(false);

        return;
      }

      toggle();
    }

    ['click'].forEach((event) => document.addEventListener(event, handleDocumentClick, true));

    return () => {
      ['click'].forEach((event) => document.removeEventListener(event, handleDocumentClick, true));
    };
  }, [toggle, container]);

  return (
    <DropdownContext.Provider value={value}>
      <div ref={container} data-testid="Dropdown">
        {typeof children === 'function' ? children(value) : children}
      </div>
    </DropdownContext.Provider>
  );
};

Dropdown.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
};

Dropdown.defaultProps = {
  children: null,
};

export default Dropdown;
